export const bArray = {
    /**
     * Возвращает true, если 'a' - это массив
     * @param a
     */
    isArray<T = unknown>(a: unknown): a is Array<T> {
        return Object.prototype.toString.call(a) === '[object Array]';
    },
    /**
     * Возвращает true, если массив пустой
     * @param a
     */
    isEmpty<T>(a: T[]): boolean {
        return a.length === 0;
    },
};
export const bArray = {
    /**
     * Возвращает true, если 'a' - это массив
     * @param a
     */
    isArray<T = unknown>(a: unknown): a is Array<T> {
        return Object.prototype.toString.call(a) === '[object Array]';
    },
    /**
     * Возвращает true, если массив пустой
     * @param a
     */
    isEmpty<T>(a: T[]): boolean {
        return a.length === 0;
    },
};
